var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { role: "dialog", id: "ModalDeleteGrupoWorker" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-md" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                { staticClass: "btn", attrs: { "data-dismiss": "modal" } },
                [_vm._v("Cancelar")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn-danger btn", on: { click: _vm.accion } },
                [_vm._v("Eliminar")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("¿Desea eliminar este grupo de workers?"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }